<template>
  <div
    id="app"
    class="login min-h-screen overflow-hidden bg-white sm:bg-gradient-to-b from-blue-100 to-white relative"
  >
    <div
      class="sm:mx-auto sm:w-full sm:max-w-xl absolute top-0 sm:top-48 inset-0 m-auto"
    >
      <div class="bg-white py-8 px-10 sm:shadow-lg sm:rounded-lg">
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
          <img class="mx-auto h-12 w-auto" src="/logo.svg" alt="Xemplo" />
          <h2 class="mt-8 font-semibold mb-4 text-center text-sm text-black">
            Please login to access your fee agreement
          </h2>
          <p class="text-center text-sm text-red-400">{{ error.message }}</p>
        </div>
        <form class="space-y-6" action="#" method="POST">
          <div>
            <label class="block text-sm font-medium text-black"> Email </label>
            <div class="mt-1">
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                v-model="email"
                required
                class="appearance-none block w-full px-3 py-2 border border-gray-500 rounded-full placeholder-gray-500 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
            </div>
          </div>

          <div>
            <label class="block text-sm font-medium text-black">
              Password
            </label>
            <div class="mt-1">
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                v-model="password"
                class="appearance-none block w-full px-3 py-2 border border-gray-500 rounded-full placeholder-gray-500 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
            </div>
          </div>
          <button
            @click.prevent="login"
            class="hover:no-underline mb-4 cursor-pointer w-full flex justify-center py-2.5 px-4 border border-transparent rounded-full text-sm font-normal text-white bg-blue-500 hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { bus } from "@/js/Bus";
import _has from "lodash/has";
import { mapActions } from "vuex";

export default {
  name: "Login",

  data: function () {
    return {
      show_chars: false,
      email: null,
      password: null,
      error: {},
      id: null,
      password_field: "password",
    };
  },

  computed: {
    has_error: function () {
      return _has(this.error, "message");
    },
  },

  watch: {
    show_chars: function (val) {
      if (val == true) {
        this.password_field = "text";
      } else {
        this.password_field = "password";
      }
    },
  },

  methods: {
    ...mapActions("client", ["updateFeeAgreement"]),
    alertDismissed: function () {
      this.error = {};
    },

    login: function (evt) {
      evt.preventDefault();

      var vm = this;
      console.log("usejrber", this.app);
      this.$http
        .post(this.app.version + "/front/login/" + this.id, {
          email: this.email,
          password: this.password,
        })
        .then(function (response) {
          vm.$auth.setToken(
            response.data.token.access_token,
            response.data.token.expires_in
          );

          bus.$emit("authenticated");
          console.log(response.data);
          vm.updateFeeAgreement(response.data.feeAgreement);
          console.log(response.data.feeAgreement);

          /** SET local variables here */
          localStorage.PORTAL_HASH = vm.id;
          localStorage.PORTAL_PROJECT = JSON.stringify(
            response.data.feeAgreement.project
          );
          localStorage.PORTAL_CLIENT = JSON.stringify(
            response.data.feeAgreement.client
          );

          let routeLink = response.data.feeAgreement.hasEligibilities
            ? "/eligibility"
            : "/agreement";
          vm.$router.push(routeLink);
        })
        .catch(function (error) {
          console.log(error);
          vm.error = error.response.data;
        });
    },
  },

  mounted() {
    this.$auth.destroyToken();
    this.id = this.$route.params.id;
  },
};
</script>

<style>
legend {
  margin-bottom: 0px;
}
</style>
